require('slick-carousel');

export function initalize() {
  $('.featured-track img[data-src]').each((_, image) => {
    $(image).attr('src', $(image).data('src'));
  });
  var slidesShown = Math.floor($(window).width() / 350);
  var slick = function(slidesToShow) {
    slidesShown = slidesToShow;
    return $('.featured-track').slick({
      arrows: false,
      dots: false,
      swipe: true,
      infinite: true,
      slidesToShow: slidesToShow,
    });
  };
  let slider = slick(slidesShown);
  $(window).resize(function() {
    var slidesToShow = Math.floor($(window).width() / 350);
    if (slidesToShow !== slidesShown) {
      $('.featured-track').slick('unslick');
      slider = slick(slidesToShow);
    }
  });
  $('.featured-left').click(() => {
    slider.slick('slickPrev');
  });
  $('.featured-right').click(() => {
    slider.slick('slickNext');
  });
}
